<script>
    import { afterUpdate } from 'svelte';

    export let boardSize;
    export let board;
    export let addToBuffer;

    let cssVars = `--size:${boardSize};`

    let frozenCoordX = null;
	let frozenCoordY = 0;
    
    function select(boardIndex) {
		if (board[boardIndex].status != "selectable") return;
        
        board[boardIndex].status = "used";
		
		let x = boardIndex % boardSize;
		let y = Math.floor(boardIndex / boardSize);
		
		if (frozenCoordX == null) {
			frozenCoordX = x;
			frozenCoordY = null;
		} else if (frozenCoordY == null) {
			frozenCoordX = null;
			frozenCoordY = y;
        }
        
        addToBuffer(board[boardIndex].value);
        updateSelectability();
    }
	
	function updateSelectability() {
		for (let i = 0; i < board.length; i++) {
			if (board[i].status == "used") continue;
			
			let x = i % boardSize;
			let y = Math.floor(i / boardSize);
			
			if (frozenCoordX != null && frozenCoordX == x) {
				board[i].status = "selectable";
			} else if (frozenCoordY != null && frozenCoordY == y) {
				board[i].status = "selectable";
			} else {
				board[i].status = null;
			}
		}
	}
    
    afterUpdate(updateSelectability);
</script>

<style>
    .board {
		display: grid;
		grid-template-columns: repeat(var(--size), 50px);
        grid-template-rows: repeat(var(--size), 50px);
	}
	
	.square {
		line-height: 50px;
		
		text-align: center;
		font-size: 100%;
		
		border: 2px solid #211e27;
	}
	
	.square.selectable {
		background-color: #2f3241;
		border: 2px solid #2f3241;
		
		cursor: pointer;
	}
	
	.square.used {
		color: #483950;
	}
	
	.square.selectable:hover {
		border: 2px solid #a6d0cf;
	}
</style>

<div class="board" style="{cssVars}">
    {#each board as number, i}
        <div class="square {number.status}" square={number} on:click="{ev => select(i)}">
            {number.value}
        </div>
    {/each}
</div>